import { SVGProps, Ref, forwardRef } from 'react';

export const MetroLineSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <rect x={6} y={2.667} width={4} height={10.667} rx={2} fill="currentColor" />
    </svg>
));
MetroLineSize16Glyph.displayName = 'MetroLineSize16Glyph';
